import { createContext } from "react";

var TokenContext = createContext(null);

export default TokenContext;